import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import AzanBox from './AzanBox';
import CalendarBox from './CalendarBox';
import CalendarButtons from './CalendarButtons';
import EventBox from './EventBox';
import CalendarBoard from './CalendarBoard';
import {getEventsOf} from './IEvent';
import HeaderWithIcons from '@components/app/HeaderWithIcons';

export default function Calendar() {
	const {t} = useTranslation();
	const [date, setDate] = useState(new Date());
	
	return (
		<div className="flex flex-col space-y-4 pb-6">
			<HeaderWithIcons title={t('calendar')}/>
			<CalendarBox/>
			<CalendarButtons date={date} setDate={setDate}/>
			<CalendarBoard date={date} setDate={setDate}/>
			<AzanBox date={date}/>
			<EventBox events={getEventsOf(date)}/>
		</div>
	);
}
